import React, { useState } from 'react';
// import CounterInput from "react-counter-input";

const CounterInput = (props) => {
  let bg = props.background;
  let color = props.color;
  let vertical = props.vertical;
  let borderColor = props.borderColor;
  let container

  if (vertical) {
    container = 'vertical'
  } else {
    container = ''
  }

  let counter = String(props.data.cantidad) 

  return (
    <div className={`counter-input ${container}`} style={{backgroundColor: bg, borderColor: borderColor}}>
      <button className='btn-link' style={{color: color}}
      onClick={() => props.eventCounter(parseInt(counter) + 1, props.data.tab, props.data.indice)}
      >+</button>
        <div className="width-machine" aria-hidden="true">{counter}</div>
        <input  style={{backgroundColor: bg, color: color}} type="number" value={counter}
        onChange={e => {let text = e.currentTarget.value; props.eventCounter(text != "" ? parseInt(text) : "", props.data.tab, props.data.indice);}}
        />
      <button className='btn-link' style={{color: color}}
      disabled={counter == 0}
      onClick={() => props.eventCounter(parseInt(counter) - 1, props.data.tab, props.data.indice)}
      >-</button>
    </div>
  )
}

export default CounterInput;